import { Input } from "~/react/ui/input"
import { Icon } from "~/react/ui/icon"
import { Button } from "~/react/ui/button"

export interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  onClear?: () => void
  placeholder?: string
  ariaLabel?: string
  clearAriaLabel?: string
  id?: string
  className?: string
}

export function SearchInput({
  value,
  onChange,
  onClear,
  placeholder,
  ariaLabel,
  clearAriaLabel,
  id,
  className,
}: SearchInputProps) {
  const handleClear = () => {
    if (onClear) {
      onClear()
    } else {
      onChange("")
    }
  }

  return (
    <div className={className || "h-search-form"}>
      <Input
        id={id}
        className="h-search-form__input"
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
      {value ? (
        <Button
          variant="ghost"
          size="xs"
          className="h-search-form__reset"
          onClick={handleClear}
          aria-label={clearAriaLabel}
          iconOnly
        >
          <Icon icon="times" aria-hidden="true" />
        </Button>
      ) : (
        <Button
          className="h-search-form__submit"
          aria-label={ariaLabel}
          data-loading="none"
          size="xs"
          iconOnly
        >
          <Icon icon="search" aria-hidden="true" />
        </Button>
      )}
    </div>
  )
}
